import React from 'react';
import { Provider } from 'react-redux';
import { hot } from 'react-hot-loader/root';
import Router from './router/index';
import store from '@/redux/store';
import './assets/css/app';
import './assets/css/common';
import { ConfigProvider } from 'antd';
import viVN from 'antd/lib/locale-provider/vi_VN';


const App = () => {
	return (
		<Provider store={store}>
			<ConfigProvider locale={viVN}>
				<Router />
			</ConfigProvider>
		</Provider>
	);
};

export default hot(App);
